// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
} from "react-admin";

const LogsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Rechercher par Id" source="id" alwaysOn />
    <TextInput label="Rechercher par date" source="date" alwaysOn />
    <TextInput label="Rechercher par email" source="email" />
    <TextInput label="Rechercher par user Id" source="uid" />
  </Filter>
);

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

export const LogsList = (props) => (
  <List {...props} filters={<LogsFilter />} pagination={<PostPagination />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="email" />
      <TextField source="uid" />
      <TextField source="path" />
      <TextField source="ip" />
      <TextField source="user_agent" />
      <TextField source="timestamp" />
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const LogsShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="email" />
      <TextField source="uid" />
      <TextField source="path" />
      <TextField source="ip" />
      <TextField source="user_agent" />
      <TextField source="timestamp" />
    </SimpleShowLayout>
  </Show>
);

export const LogsEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      <TextInput source="id" />
      <TextInput source="title" />
      <TextInput source="email" />
      <TextInput source="uid" />
      <TextInput source="path" />
      <TextInput source="ip" />
      <TextInput source="user_agent" />
      <TextInput source="timestamp" />
    </SimpleForm>
  </Edit>
);
